/* eslint-disable no-use-before-define */
const theme = {
  colors: {
    orange: 'hsl(26, 100%, 55%)',
    paleOrange: 'hsl(25, 100%, 94%)',
    darkBlue: 'hsl(220, 13%, 13%)',
    darkGrayBlue: 'hsl(219, 9%, 45%)',
    grayBlue: 'hsl(220, 14%, 75%)',
    lightGrayBlue: 'hsl(223, 64%, 98%)',
    white: 'hsl(0, 0%, 100%)',
    black: 'hsl(0, 0%, 0%)',
    lightbox: 'rgba(0, 0, 0, 0.75)',
  },
  media: {
    minLarge: 1040,
  },
  mediaQueries: {
    minLarge: `(min-width: 1040px)`,
  },
};

export { theme };
